<div class="root tw-process-state">
  <tw-icon class="state icon" icon="success" key="success" v-if="success" /> 
  <tw-icon class="state icon" icon="error" key="error" v-else-if="error" /> 
  <transition name="load" appear>
    <tw-loader class="state loading" width="2" key="loading" v-if="!success && !error" />
  </transition>
</div>
